<template>
    <!-- breed selector for dog insurance -->
    <div v-if="policyAttributes.some(e => e === 'breedOfDog')">
        <label for="breedOfDog">
            <span class="headline" v-text="lang.breedOfDog"/>
        </label>
        <div class="dropdown-list">
            <v-select
                :options="filteredBreedsOfDog"
                :placeholder="lang.selectBreedOfDog"
                :value="breedOfDogSelector.selected.label"
                id="breedOfDog"
                class="vs-search"
                @input="setSelectedBreedOfDog"
                @search="(query) => (breedOfDogSelector.search = query)"
            >
                <template #no-options="{}">
                    {{ lang.no_options_found }}
                </template>
            </v-select>
        </div>
        <input id="breedOfDogCategory" type="hidden" :value="breedOfDogSelector.selected.category || 0"/>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: ['product', 'coverages', 'policyAttributes', 'productSelector', 'selectedPolicyAttributes', 'lang', 'queryParam', 'connectApiUrl'],
    name: "PolicyAttributes",
    data: function () {
        return {
            locationPathName: '',
            breedOfDogSelector: {
                options: [],
                selected: {
                    label: null,
                    category: null
                },
                search: ''
            },
            firstFetch: true
        }
    },
    computed: {
        dogBreedApiUrl() {
            return this.connectApiUrl + '/product-configuration/dog-breeds?page=0'
        },
        filteredBreedsOfDog() {
            this.popularDogBreed = this.breedOfDogSelector.options.filter(
                (breed) => this.productSelector.popularDogBreed
                    .includes(breed.breedName)).map(e => ({label: e.breedName, category: e.category}));
            this.separator = this.productSelector.separator;
            this.breedList = this.breedOfDogSelector.options.filter((breed) =>
                breed.breedName.toLowerCase().includes(this.breedOfDogSelector.search.toLowerCase()) &&
                !this.popularDogBreed.some(b => breed.breedName.toLowerCase() === b.label.toLowerCase())
            )
                .map(e => ({label: e.breedName, category: e.category}))
                .sort((a, b) => {
                    if (a.label < b.label) return -1;
                    if (a.label > b.label) return 1;
                    return 0;
                });
            return this.popularDogBreed.concat([this.separator].concat(this.breedList));
        }
    },
    methods: {
        setSelectedBreedOfDog(selected) {
            if (selected == null) {
                this.$emit('setRemove');
                this.breedOfDogSelector.selected = {label: null, category: null};
            } else {
                this.breedOfDogSelector.selected = selected;
                this.selectedPolicyAttributes['breedOfDog'] = selected.label;
                this.selectedPolicyAttributes['breedClassOfDog'] = selected.category;
                const categoryMap = {
                    "SMALLER_THAN_44_CM": 1,
                    "LARGER_THAN_44_CM": 2,
                    "SPECIAL": 3,
                    "UNINSURABLE": 4
                };
                const category = categoryMap[selected.category];
                if (category !== 4) {
                    this.$emit('changeCoverage', this.findCoverage(category));
                }
                this.$emit('setSelectedDog', selected);
            }
        },
        findCoverage(price) {
            return this.coverages.filter(coverage => coverage.sum >= price).sort((a, b) => a.sum - b.sum)[0];
        }
    },
    created() {
        if (this.policyAttributes.some(e => e === 'breedOfDog')) {
            axios.get(this.dogBreedApiUrl).then(response => {
                this.breedOfDogSelector.options = response.data;
                if (this.queryParam.breedOfDog) {
                    // Preselect Breed of Dog with the given query parameter
                    let queryBreed = decodeURI(this.queryParam.breedOfDog).replaceAll("+", " ");
                    let queryResponseBreed = response.data.filter(breed => breed.breedName === queryBreed);
                    if (queryResponseBreed.length > 0) {
                        queryResponseBreed[0].label = queryResponseBreed[0].breedName;
                        this.setSelectedBreedOfDog(queryResponseBreed[0])
                    }
                }
            });
        }
    }
}
</script>

<style scoped>
</style>
